import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('embedded-academy-ui');